import classNames from 'classnames';
import React from 'react';
import styles from './badge.css';
import { Button } from './button';
import { IconClear } from './icons';
import { TextTiny } from './typography';

export function Badge({
  variant,
  label,
  onRemove,
}: {
  variant: 'ai' | 'orange' | 'grey2' | 'gradient' | 'green';
  label: string;
  onRemove?(): void;
}) {
  return (
    <div
      className={classNames(
        styles.badge,
        styles[variant],
        onRemove && styles.hasRemove,
      )}
    >
      <div className={styles.badgeText}>
        <TextTiny>{label}</TextTiny>
      </div>
      {onRemove && (
        <Button
          variant="tertiary"
          size="small"
          icon={IconClear}
          onClick={onRemove}
        />
      )}
    </div>
  );
}
